import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=c2f7d924&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2f7d924')) {
      api.createRecord('c2f7d924', component.options)
    } else {
      api.reload('c2f7d924', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=c2f7d924&", function () {
      api.rerender('c2f7d924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/report/Comment.vue"
export default component.exports